import React, { useMemo } from 'react';
import { ContributionReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useContributionInvoiceBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'contribution-invoice-report-card';
const ContributionInvoiceCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const { date, amount, isLoading } = useContributionInvoiceBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem && (date || amount || isLoading)) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title="Most recent invoice"
          items={[
            {
              label: 'Date',
              value: date ? date : '',
            },
            {
              label: 'Amount',
              value: amount ? amount : '',
            },
          ]}
        />
      );
    }
    return null;
  }, [amount, date, isLoading, isSystem]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.ContributionInvoice);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      testId={TEST_ID}
      url={ROUTES.CONTRIBUTION_INVOICE_REPORT}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <ContributionReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Contribution Invoice"
      description="Reconcile contribution invoicing
and view invoice details. This report is
limited to contribution funded accounts"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default ContributionInvoiceCard;
